/* =========================================================
   TenutaCart — thin wrapper around Shopify's Ajax Cart API.
   Used by base-ui.js so all the existing button/interaction
   code (add to cart pulses, cart-page qty steppers, etc.)
   can talk to a REAL Shopify cart instead of faking it locally.
   ========================================================= */
window.TenutaCart = (function () {
  // Resolved fresh on every call (rather than once at parse time) and
  // always normalized to have a leading AND trailing slash. Without this,
  // an unexpected value from window.Shopify.routes.root (e.g. missing a
  // trailing slash, or resolving oddly on locale-prefixed / proxied
  // stores) turns "cart/add.js" into a path the browser resolves
  // relative to the *current page*, not the site root — which 404s.
  function getRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    if (root.charAt(0) !== "/") root = "/" + root;
    if (root.charAt(root.length - 1) !== "/") root = root + "/";
    return root;
  }

  function updateCartCount(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle("is-empty", cart.item_count === 0);
    });
  }

  function refreshCount() {
    return fetch(getRoot() + "cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCartCount(cart); return cart; });
  }

  function add(variantId, quantity) {
    return fetch(getRoot() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (item) {
        return refreshCount().then(function () { return item; });
      });
  }

  function change(key, quantity) {
    return fetch(getRoot() + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCartCount(cart); return cart; });
  }

  function clear() {
    return fetch(getRoot() + "cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCartCount(cart); return cart; });
  }

  // Cart attributes (as opposed to line-item properties) live on the cart
  // as a whole and carry straight through to the order — they show up
  // under "Additional details" on the order in Shopify admin. Shopify
  // merges whatever keys you send here into the existing attributes hash,
  // it doesn't wipe out attributes you don't mention (e.g. shipping_speed
  // survives an event_name update and vice versa), so callers only ever
  // need to send the key(s) they're changing.
  function updateAttributes(attributes) {
    return fetch(getRoot() + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (cart) { updateCartCount(cart); return cart; });
  }

  document.addEventListener("DOMContentLoaded", refreshCount);

  return { add: add, change: change, clear: clear, updateAttributes: updateAttributes, refreshCount: refreshCount };
})();